import { createContext } from "react";
import type { AlertType } from "./types";

interface AlertContextType {
  showAlert: (
    message: string,
    description?: string,
    type?: AlertType,
    icon?: React.ReactNode
  ) => void;
}

export const AlertContext = createContext<AlertContextType | undefined>(
  undefined
);
